export const MODES = {
  CHAT: "chat",
  NOTEBOOK: "notebook",
  NONE: null,
};
export const modeSlice = (set, get) => ({
  mode: MODES.NONE,
  setMode: (mode) => set({ mode: mode }),
});
